import React from "react";
import ComponentHealthSection from "v2/components/ComponentHealthSection";
import { usePayloadContext } from "components/usePayloadContext";

// Crawl up the component group tree to find all groups that are parents of a component
const getAllGroupsWithComponent = (component, groupDict = {}) => {
  const foundGroups = [];
  let parentGroup = groupDict[component.componentGroupId];
  while (parentGroup) {
    foundGroups.push(parentGroup);
    parentGroup = groupDict[parentGroup.componentGroupId];
  }
  return foundGroups;
};

// retrurn component groups that are used by a component
const getFilteredComponentGroups = (
  componentGroups = [],
  filteredComponents = []
) => {
  const foundGroupSet = new Set();
  const groupDict = componentGroups.reduce((acc, group) => {
    acc[group.id] = group;
    return acc;
  }, {});
  filteredComponents.forEach((component) => {
    const groups = getAllGroupsWithComponent(component, groupDict);
    groups.forEach((group) => {
      foundGroupSet.add(group.id);
    });
  });
  return Array.from(foundGroupSet)?.map((id) => groupDict[id]);
};

const IncidentAffectedComponents = ({ incident }) => {
  const { components, componentGroups } = usePayloadContext();
  const componentNames = Object.keys(incident?.componentConditions || {});
  const componentIds = (incident?.components || [])
    .map((component) => component?.id)
    .filter(Boolean);
  const incidentComponentNames = (incident?.components || [])
    .map((component) => component?.name)
    .filter(Boolean);

  // Components that are affected by this incident but we need the ones with ids
  const filteredComponents = components?.filter((component) => {
    if (componentIds.length > 0 && componentIds.includes(component.id)) {
      return true;
    }
    if (
      componentNames.length > 0 &&
      componentNames.indexOf(component.name) > -1
    ) {
      return true;
    }
    return incidentComponentNames.indexOf(component.name) > -1;
  });

  const filteredComponenntGroups = getFilteredComponentGroups(
    componentGroups,
    filteredComponents
  );
  if (!filteredComponents?.length) return null;
  return (
    <ComponentHealthSection
      components={filteredComponents}
      componentGroups={filteredComponenntGroups}
      showBreadcrumbs
    />
  );
};

export default IncidentAffectedComponents;
